// DON't forget update index.html after update types!
export interface IEnvConfig {
  SENTRY_DSN: string;
  VITE_SENTRY_DSN: string;
  NODE_ENV: string;
  GOOGLE_TAG_ID: string;
  VITE_GOOGLE_TAG_ID: string;
  META_PIXEL_ID: string;
  VITE_META_PIXEL_ID: string;
  TIKTOK_PIXEL_ID: string;
  VITE_TIKTOK_PIXEL_ID: string;
  RELEASE_VERSION: string;
  VITE_RELEASE_VERSION: string;
}

export const envConfig = (
  import.meta.env.MODE === 'development'
    ? {
        NODE_ENV: import.meta.env.MODE,
        VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
        VITE_GOOGLE_TAG_ID: import.meta.env.VITE_GOOGLE_TAG_ID as string,
        VITE_META_PIXEL_ID: import.meta.env.VITE_META_PIXEL_ID as string,
        VITE_TIKTOK_PIXEL_ID: import.meta.env.VITE_TIKTOK_PIXEL_ID as string,
        VITE_RELEASE_VERSION: import.meta.env.VITE_RELEASE_VERSION as string,
      }
    : (window as any).env
) as IEnvConfig;
